var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIncome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.813,
    height: 30.478,
    viewBox: "0 0 38.813 30.478",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-cash",
    "data-name": "Icon ionic-ios-cash",
    transform: "translate(-2.25 -5.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5145",
    "data-name": "Path 5145",
    d: "M39.85,25.024H3.463a1.213,1.213,0,0,0,0,2.426H39.85a1.213,1.213,0,0,0,0-2.426Z",
    transform: "translate(0 4.502)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5146",
    "data-name": "Path 5146",
    d: "M39.85,28.4H3.463a1.213,1.213,0,0,0,0,2.426H39.85a1.213,1.213,0,0,0,0-2.426Z",
    transform: "translate(0 5.285)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5147",
    "data-name": "Path 5147",
    d: "M38.022,5.632H5.291A3.05,3.05,0,0,0,2.25,8.673v15.4a3.05,3.05,0,0,0,3.041,3.041H38.022a3.05,3.05,0,0,0,3.041-3.041V8.673A3.05,3.05,0,0,0,38.022,5.632ZM9.354,24.345H6.235a1.213,1.213,0,0,1,0-2.426H9.354a1.213,1.213,0,0,1,0,2.426Zm0-13.515H6.235a1.213,1.213,0,1,1,0-2.426H9.354a1.213,1.213,0,0,1,0,2.426Zm12.3,12.475a6.931,6.931,0,1,1,6.931-6.931A6.94,6.94,0,0,1,21.656,23.306Zm15.421,1.04H33.958a1.213,1.213,0,0,1,0-2.426h3.119a1.213,1.213,0,0,1,0,2.426Zm0-13.515H33.958a1.213,1.213,0,0,1,0-2.426h3.119a1.213,1.213,0,1,1,0,2.426Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5148",
    "data-name": "Path 5148",
    d: "M23.457,15.349a4.592,4.592,0,1,1-4.592-4.592,4.592,4.592,0,0,1,4.592,4.592Z",
    transform: "translate(2.791 1.19)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncome);
export default __webpack_public_path__ + "static/media/income.da76cb33fbbfd543f8c1eef69ca84676.svg";
export { ForwardRef as ReactComponent };